

































































import {Component, Prop, Vue} from "vue-property-decorator";
import {getDateByString, getMonthName} from "@/lib/date";
import XButton from "../SimpleButton.vue";
import {AppealCustomFields} from "@/models/appeals";


@Component({
  components: {XButton},
})
class DateMonthCustomField extends Vue {
  [x: string]: any;

  @Prop({ required: true }) readonly item!: AppealCustomFields;
  @Prop({ default: "" }) readonly fieldName!: string;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: () => [] }) errorMessages: any;

  isDropdownDisplayed = false;

  dates: string[] = [];
  value = "";

  emptyValue = "__.____ - __.____";

  public created() {
    this.value = this.emptyValue;
  }

  customRuleMonth() {
    if (this.required) {
      return [
        v => (v || this.emptyValue) !== this.emptyValue || "Заполните данное поле",
      ];
    }
    return [];
  }

  public applyDateChanges() {
    const isoDates = this.dates.map((date) => getDateByString(date));
    const parsedDates = isoDates.map((date) => Date.parse(date.toString()));
    if (parsedDates[0] > parsedDates[1]) {
      this.dates = isoDates.reverse();
    } else {
      this.dates = isoDates;
    }

    this.value = this.dates[0].split('T')[0].split('-').reverse().join('.')
      + " - " + this.dates[1].split('T')[0].split('-').reverse().join('.');
    this.item['значение'] = "01." + this.dates[0].split('T')[0].split('-').reverse().join('.')
      + "-01." + this.dates[1].split('T')[0].split('-').reverse().join('.');
    this.item['ошибка'] = "";

    this.isDropdownDisplayed = false;
  }

  public resetDateChanges() {
    this.dates = [];
    this.value = this.emptyValue;
    this.item['значение'] = "";
    this.item['ошибка'] = "";
    this.isDropdownDisplayed = false;
  }

  public formatMonth(date: string): string {
    return getMonthName(date, true).toUpperCase();
  }
}

export default DateMonthCustomField;
